import axios from "@/api/config";

const schoolPageTemplate = {
  getSchoolPageTemplateList(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPageTemplate/getSchoolPageTemplateList`, {
        params: data
      }
    );
  },
  getFlashSaleGoodsList(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPage/getFlashSaleGoodsList`, {
        params: data
      }
    );
  },
  addSchoolPageTemplate(data) {
    return axios.post(
      `${process.env.BASE_URL}/schoolPageTemplate/addSchoolPageTemplate`,
      data
    );
  },

  updateSchoolPageTemplate(data) {
    return axios.put(
      `${process.env.BASE_URL}/schoolPageTemplate/updateSchoolPageTemplate`,
      data
    );
  },

  pageList(data) {
    return axios.post(
      `${process.env.BASE_URL}/schoolPageTemplate/pageList`,
      data
    );
  },
  deleteSchoolPageTemplate(data) {
    return axios.delete(
      `${process.env.BASE_URL}/schoolPageTemplate/deleteSchoolPageTemplate`, {
        data: data
      }
    );
  }
};

export default schoolPageTemplate;



// WEBPACK FOOTER //
// ./src/api/schoolPageTemplate.js